<template>
  <BOverlay
    :show="loadingSearch || loadingCalculatePrice"
    rounded="sm"
    variant="transparent"
    spinner-variant="info"
    opacity="0.95"
    no-fade
  >
    <!-- ANCHOR - HÀNH TRÌNH -->
    <AppCollapse
      type="card"
      class="mb-75"
    >
      <AppCollapseItem
        title
        isVisible
        classHeader="border-bottom"
        classBody="p-50"
      >
        <template #header>
          <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
            Chuyến bay đã chọn
          </div>
        </template>

        <ClassBookingProBookTrip />
      </AppCollapseItem>
    </AppCollapse>

    <!-- ANCHOR - TÍNH GIÁ -->
    <AppCollapse
      type="card"
      class="mb-75"
    >
      <AppCollapseItem
        title
        isVisible
        classHeader="border-bottom"
        classBody="p-50"
      >
        <template #header>
          <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
            Tính giá
          </div>
        </template>

        <ClassBookingProBookCalculateOption />
      </AppCollapseItem>
    </AppCollapse>

    <!-- ANCHOR - GIÁ VÉ -->
    <AppCollapse
      type="card"
      class="mb-75"
    >
      <AppCollapseItem
        title
        isVisible
        classHeader="border-bottom"
        classBody="p-50"
      >
        <template #header>
          <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
            Giá vé
            <template v-if="resultCalculatePrice">
              ( <span class="text-airline">{{ resultCalculatePrice[0].currency }}</span> )
            </template>
          </div>
        </template>

        <ClassBookingProBookPrice />
      </AppCollapseItem>
    </AppCollapse>

    <ValidationObserver ref="refPaxAndCustomerInfo">
      <!-- ANCHOR - THÔNG TIN HÀNH KHÁCH -->
      <AppCollapse
        type="card"
        class="mb-75"
      >
        <AppCollapseItem
          ref="refPaxCollapseItem"
          title
          isVisible
          classHeader="border-bottom"
          classBody="p-50"
        >
          <template #header>
            <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
              Thông tin hành khách
            </div>
          </template>

          <!-- <div
            v-for="(pax) of passengerLists"
            :key="pax.paxId"
          >
            {{ pax.paxId }} -->
          <ClassBookingProBookPassenger
            :customerId="customerId"
            :passengerDataToAdd="passengerLists"
          />
          <!-- </div> -->
        </AppCollapseItem>
      </AppCollapse>

      <!-- ANCHOR - THÔNG TIN KHÁCH HÀNG -->
      <b-card
        class="shadow"
        no-body
      >
        <BookingAgencyDetail
          :agency-data.sync="agencyData"
          :checkboxCustomerDataReplacePhoneAgencyData.sync="checkboxCustomerDataReplacePhoneAgencyData"
          :checkboxCustomerDataReplaceEmailAgencyData.sync="checkboxCustomerDataReplaceEmailAgencyData"
          :is-role-f1="isRoleF1"
          :enable-send-employee-mail-airline="enableSendEmployeeMailAirline"
          :is-collapsed="isCollapsedAgencyAndContactDetail"
          @toggleCollapse="toggleIsCollapsedAgencyAndContactDetail"
        />
        <BookingContactDetail
          :customer-data.sync="customerData"
          :checkboxCustomerDataReplacePhoneAgencyData.sync="checkboxCustomerDataReplacePhoneAgencyData"
          :checkboxCustomerDataReplaceEmailAgencyData.sync="checkboxCustomerDataReplaceEmailAgencyData"
          :is-role-f3="isRoleF3"
          :is-collapsed="isCollapsedAgencyAndContactDetail"
          @toggleCollapse="toggleIsCollapsedAgencyAndContactDetail"
          @resetAgencyData="resetAgencyData"
        />
      </b-card>
    </ValidationObserver>

    <div class="m-75">
      <BFormCheckbox
        v-model="retain"
        name="savePriceToBooking"
        class="custom-control-warning"
      >
        <span class="font-weight-bold text-body">
          Lưu giá vé
        </span>
      </BFormCheckbox>
      <p class="text-danger font-small-4 font-weight-bolder">
        Lưu ý: Trong trường hợp đặt sổ chờ (HL), đặt DS hoặc đặt nhiều hạng trên 1 chuyến bay bạn nên tắt chức năng lưu giá vé tránh bị lỗi!
      </p>
    </div>

    <!-- ANCHOR - BUTTONs ĐẶT VÉ -->
    <div class="d-flex-center mb-1 gap-3">
      <b-button
        variant="outline-secondary"
        pill
        class="mr-1"
        @click="() => this.$router.go(-1)"
      >
        Quay lại
      </b-button>
      <b-button
        variant="warning"
        pill
        @click="createBookingHandle"
      >
        Đặt vé
      </b-button>
    </div>

    <!-- ANCHOR - Booking -->
    <AppCollapse
      v-if="resultCreatedBooking"
      type="card"
      class="mb-75"
    >
      <AppCollapseItem
        title
        isVisible
        classHeader="border-bottom"
        classBody="p-50"
      >
        <template #header>
          <div :class="`text-airline fw-700 ${isMobileView ? 'font-medium-2' : 'font-medium-3'}`">
            Booking
          </div>
        </template>

        <ClassBookingProBookInfoBooking />
      </AppCollapseItem>
    </AppCollapse>
  </BOverlay>
</template>

<script>
import {
  BCard,
  BButton,
  BOverlay,
  BFormCheckbox,
} from 'bootstrap-vue'
import {
  computed, ref,
  // onBeforeUpdate,
} from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { isEmpty } from 'lodash-es'

import { getUserData } from '@/api/auth/utils'
import store from '@/store'
import { convertISODateTime } from '@/@core/utils/filter'
import env from '@/libs/env'

import useToast from '@useToast'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BCard,
    BButton,
    BOverlay,
    BFormCheckbox,
    ValidationObserver,

    AppCollapse: () => import('@/@core/components/app-collapse/AppCollapse.vue'),
    AppCollapseItem: () => import('@/@core/components/app-collapse/AppCollapseItem.vue'),

    ClassBookingProBookTrip: () => import('./ClassBookingProBookTrip.vue'),
    ClassBookingProBookCalculateOption: () => import('./ClassBookingProBookCalculateOption.vue'),
    ClassBookingProBookPrice: () => import('./ClassBookingProBookPrice.vue'),
    ClassBookingProBookPassenger: () => import('./ClassBookingProBookPassenger.vue'),
    ClassBookingProBookInfoBooking: () => import('./ClassBookingProBookInfoBooking.vue'),

    BookingContactDetail: () => import('@flightv2/reservation/BookingContactDetail.vue'),
    BookingAgencyDetail: () => import('@flightv2/reservation/BookingAgencyDetail.vue'),

  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProBook' ")
    // })

    const {
      loadingSearch,
      loadingCalculatePrice,
      retain,
      selectedTrips,
      passengerLists,
      resultCalculatePrice,
      resultCreatedBooking,
      // refPaxAndCustomerInfo,
      createBooking,
    } = useClassBookingPro()

    const { toastError } = useToast()
    const { isAutoCheckboxInContactsInfo } = env

    const refPaxAndCustomerInfo = ref(null)

    // ==== AGENCY ===========
    const isRoleF1 = computed(() => store.getters['userStore/getRoleMama'])
    const isRoleF2 = computed(() => store.getters['userStore/getRoleF2'])
    const isRoleF3 = computed(() => store.getters['userStore/getRoleCTV'])
    const agencyDataStore = computed(() => store.getters['userStore/getAgencyData'])
    const meDataStore = computed(() => store.getters['userStore/getMeData'])
    const enableSendEmployeeMailAirline = computed(() => agencyDataStore.value?.enableSendEmployeeMailAirline && isRoleF2.value)

    const customerData = ref(null)
    const customerId = computed(() => customerData.value?.paxId || 0)

    const agencyData = ref(isRoleF1.value
      ? { ...meDataStore.value }
      : {
        ...agencyDataStore.value,
        phoneNumber: agencyDataStore.value?.agencyOwner?.phoneNumber,
      })

    const checkboxCustomerDataReplacePhoneAgencyData = ref(false)
    const checkboxCustomerDataReplaceEmailAgencyData = ref(false)

    function resetAgencyData() {
      agencyData.value = { ...store.getters['userStore/getMeData'] }
    }

    const isCollapsedAgencyAndContactDetail = ref(true)
    function toggleIsCollapsedAgencyAndContactDetail() {
      isCollapsedAgencyAndContactDetail.value = !isCollapsedAgencyAndContactDetail.value
    }
    // ==== CUSTOMER ===========

    function modifyPayload(trips) {
      const result = {
        contact: getUserData().employeeData.id,
        airlineContact: {
          phoneNumber: checkboxCustomerDataReplacePhoneAgencyData.value || (isAutoCheckboxInContactsInfo && !isRoleF3.value && customerData.value?.phone) ? customerData.value.phone : agencyData.value.phoneNumber,
          email: (checkboxCustomerDataReplaceEmailAgencyData.value || (isAutoCheckboxInContactsInfo && !isRoleF3.value)) && customerData.value?.email ? (customerData.value.email ?? '') : (agencyData.value.emailAddress ?? ''),
        },
        itineraries: [],
        splitItineraries: false,
        retain: retain.value,
        flightType: 'OW',
        type: 'VN1A',
      }

      if (!customerData.value) {
        result.paxContact = null
      } else if (customerData.value.firstName || customerData.value.lastName) {
        result.paxContact = customerData.value
      } else {
        result.paxContact = {
          ...customerData.value,
          firstName: passengerLists.value[0].firstName,
          lastName: passengerLists.value[0].lastName,
        }
      }

      // --- ITINERARIES ---
      trips.forEach(trip => {
        result.itineraries.push({
          source: 'VN1A',
          airline: trip.segments[0].airline,
          clientId: '',
          bookingKey: '',
          fareBreakdowns: [...new Set(passengerLists.value.map(p => p.paxType))].map(paxType => ({
            paxType,
            netFare: 0,
            discountAmount: 0,
            discountAmountParent: 0,
            tax: 0,
            total: 0,
            fareValue: '',
          })),
          segments: trip.segments.map((segment, indexSegment) => ({
            leg: indexSegment + 1,
            airline: segment.airline,
            departure: segment.departure,
            arrival: segment.arrival,
            departureTime: convertISODateTime(segment.departureDate, segment.departureTimezone).ISOdatetime,
            arrivalTime: convertISODateTime(segment.arrivalDate, segment.arrivalTimezone).ISOdatetime,
            fareType: '',
            fareBasisCode: '',
            marriageGrp: '',
            groupClass: '',
            segmentValue: '',
            bookingClass: segment.bookingClass.code,
            bookingClassId: segment?.bookingClassId || '',
            segmentId: trip.length > 1 ? String(indexSegment + 1) : '',
            operating: segment.operating || null,
            flightNumber: String(segment.flightNumber),
            status: segment.bookingClass.status,
          })),
        })
      })

      // --- PAXLISTS ---
      result.paxLists = passengerLists.value.map(pax => ({
        ...pax,
        PaxDocuments: pax.PaxDocuments[0].number ? pax.PaxDocuments : [],
        memberFly: !isEmpty(pax?.memberFly?.cardNumber)
          ? [{
            cardNumber: String(pax.memberFly.cardNumber),
            airline: pax.memberFly.airline,
            supplierCode: pax.memberFly.airline,
          }]
          : undefined,
        birthday: (!isEmpty(pax.birthday) && pax.isSetBirthday) ? new Date(pax.birthday).toISOString() : undefined,
      }))

      return result
    }

    function createBookingHandle() {
      refPaxAndCustomerInfo.value
        .validate()
        .then(async isSuccess => {
          if (!isSuccess) {
            if (isCollapsedAgencyAndContactDetail.value) {
              toggleIsCollapsedAgencyAndContactDetail()
            }
            if (this.$refs.refPaxCollapseItem && !this.$refs.refPaxCollapseItem.visible) {
              this.$refs.refPaxCollapseItem.updateVisible()
            }
            toastError({ content: 'Vui lòng kiểm tra lại và điền đầy đủ thông tin khách hàng !' })
            return
          }

          const checkedTrips = selectedTrips.value.filter(trip => trip.isChecked)
          if (isEmpty(checkedTrips)) {
            toastError({ content: 'Vui lòng tích chọn hành trình để đặt vé !' })
            return
          }

          try {
            this.$bvModal.show('modal-api-loading')
            const dataPayload = modifyPayload(checkedTrips)
            await createBooking(dataPayload)
          } catch (error) {
            // emit('scroll-to-create-booking') // FIXME: scroll to booking
            console.error({ error })
          } finally {
            this.$bvModal.hide('modal-api-loading')
          }
        })
    }

    return {
      refPaxAndCustomerInfo,
      loadingSearch,
      loadingCalculatePrice,
      retain,
      resultCalculatePrice,
      resultCreatedBooking,
      selectedTrips,
      passengerLists,

      agencyData,
      customerData,
      customerId,
      isRoleF1,
      isRoleF3,
      enableSendEmployeeMailAirline,
      isCollapsedAgencyAndContactDetail,
      checkboxCustomerDataReplacePhoneAgencyData,
      checkboxCustomerDataReplaceEmailAgencyData,
      resetAgencyData,
      toggleIsCollapsedAgencyAndContactDetail,

      createBookingHandle,
    }
  },
}
</script>
